<template lang="pug">
  //- This template should only be used in components/chat/Bubble.vue
  div(class="c-video-thumbnail" @click="onClick()" data-testid="video-thumbnail-container")
    div(class="c-video-thumbnail__play-btn")
      BLBPicture(src="/images/mitra-chat/play_blue.png" :webp="true")
    video(class="c-video-thumbnail__video" data-testid="video-thumbnail-video")
      source(:src="url" type="video/mp4" data-testid="video-thumbnail-source")
</template>

<script>
import BLBPicture from '~/components/shared/BLBPicture';

export default {
  name: 'VideoThumbnail',
  components: {
    BLBPicture,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$emit('media-thumbnail-click', { url: this.url, mediaType: 'video' });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-video-thumbnail {
  max-width: 200px;
  height: 120px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &__play-btn {
    background-color: #fff;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -24px;
    margin-left: -24px;

    > * {
      margin-top: 4px;
    }
  }

  &__video {
    width: auto;
    height: 100%;
  }
}
</style>
